import { Moment } from 'moment';
import { React } from 'Imports';
import { VideoEventResponse, VideoEventScoreResponse } from '$Generated/api';
import * as DateFormatter from '$Components/Shared/DateFormatter';
import * as scssStyles from '../../../css/settings.scss';
import { isEncompass } from '$Utilities/integrationPlatform';
import { TruncatedText } from '$Components/Shared/TruncatedText';

const styles = require('./VideoEventInfo.scss') as {
    driver: string;
    flexColumn: string;
    displayIcons: string;
    infoTextEncompass: string;
    infoTextGeotab: string;
    date: string;
    camera: string;
    vehicleDescription: string;
    score: string;
    scoreGeotab: string;
    videoEventInfo: string;
    videoEventInfoEncompass: string;
    scrollDesignEncompass: string;
    scrollDesignGeotab: string;
    scrollBarBottomVideoRecall: string;
    rowTitleEncompass: string;
    rowTitleGeotab: string;
    flexRowTitleColumn: string;
};

interface IInfoItemProps {
    rowTitle: string;
    info: (string | undefined)[];
    className: string;
}

const InfoItem = ({ rowTitle, info, className }: IInfoItemProps) => {
    return (
        <div className={className}>
            <div className={styles.flexRowTitleColumn}>
                <span className={isEncompass ? styles.rowTitleEncompass : styles.rowTitleGeotab}>{rowTitle}</span>
            </div>
            <div className={styles.flexColumn}>
                {info.map((i, index) => (
                    <TruncatedText className={isEncompass ? styles.infoTextEncompass : styles.infoTextGeotab} key={index}>
                        {i ?? ''}
                    </TruncatedText>
                ))}
            </div>
        </div>
    );
};

interface IVideoEventInfoProps {
    event: VideoEventResponse;
    eventDate: Moment;
    className?: string;
    children?: any;
    videoEventRatings?: VideoEventScoreResponse[] | undefined;
}

type VideoEventInfoProps = IVideoEventInfoProps;

const VideoEventInfo = (props: VideoEventInfoProps) => {
    const scrollBarDesignStyle = scssStyles.styleEnvironment === 'encompass' ? styles.scrollDesignEncompass : styles.scrollDesignGeotab;
    const scrollBarStyles = `${scrollBarDesignStyle}`;
    const scoreDisplayName = props.videoEventRatings?.find((score) => score.value === props.event.score)?.displayName || 'Unscored';

    return (
        <div className={`${styles.videoEventInfo} ${isEncompass ? styles.videoEventInfoEncompass : ''} ${props.className}`}>
            <InfoItem rowTitle="Driver" info={[props.event.driverName?.trim() || 'Unknown']} className={styles.driver}></InfoItem>
            <InfoItem
                rowTitle="Vehicle"
                info={[props.event.vehicleDescription?.trim() || props.event.integrationPartnerVehicleId || 'Unknown']}
                className={styles.vehicleDescription}
            ></InfoItem>
            <InfoItem rowTitle="Camera" info={[props.event.cameraDeviceSerialNumber]} className={styles.camera}></InfoItem>
            <InfoItem
                rowTitle="Date/Time"
                info={[DateFormatter.dateAndTimezoneWithSeconds(props.eventDate)]}
                className={styles.date}
            ></InfoItem>
            <InfoItem
                rowTitle="Score"
                info={[scoreDisplayName]}
                className={`${styles.score} ${isEncompass ? '' : styles.scoreGeotab}`}
            ></InfoItem>
            <div className={scrollBarStyles}></div>
            {props.children}
        </div>
    );
};

export default VideoEventInfo;
